<template>
  <div class="card">
    <div class="card-content">
      <div class="media">
        <div class="media-content">
          <p class="title is-5">
            {{ usuario.nombre }}
          </p>
          <p class="subtitle is-6">
            {{ usuario.id }}
          </p>
          <p v-if="zonas.length > 0" class="subtitle is-6">
            Zonas: {{ nombresZonas }}
          </p>
        </div>
      </div>
      <div class="content">
        <div v-if="disponibilidades.length === 0">
          <div class="notification">
            No hay intervalos de tiempo activos en este momento
          </div>
        </div>
        <div v-if="disponibilidades.length > 0">
          <table class="is-bordered is-narrowed">
            <thead>
              <tr>
                <th width="22.5%">Desde</th>
                <th width="22.5%">Hasta</th>
                <th width="30%">Motivo</th>
                <th width="15%">Activo</th>
                <th width="10%" />
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in disponibilidades" :key="item.id">
                <td>{{ format(parseISO(item.inicio), 'dd/MM HH:mm') }}</td>
                <td>{{ format(parseISO(item.termino), 'dd/MM HH:mm') }}</td>
                <td>{{ item.descripcion }}</td>
                <td class="has-text-centered">
                  <b-icon
                    :icon="definirIcono(item.estaOperativo)"
                    :type="definirColor(item.estaOperativo)"
                  />
                </td>
                <td>
                  <b-button
                    v-if="item.esCancelable"
                    type="is-danger"
                    size="is-small"
                    icon-left="trash-alt"
                    @click="confirmarEliminacionDisponibilidad(item.id)"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <cambio-estado
            :key="`form-${usuario.id}`"
            :usuario="usuario"
            @cambiar-estado="cambiarEstadoHandle"
          />
        </div>
      </div>
      <b-loading
        :is-full-page="false"
        :can-cancel="false"
        :active.sync="isLoading"
      />
    </div>
  </div>
</template>

<script>
import { format, parseISO } from 'date-fns'

import disponibilidadMixin from '@/mixins/disponibilidad.js'
import CambioEstado from '@/components/controlUsuarios/CambioEstado'
import { usuarioService } from '@/services'

export default {
  name: 'DetalleUsuario',
  components: {
    CambioEstado
  },
  mixins: [disponibilidadMixin],
  props: {
    usuario: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      format,
      parseISO,
      isLoading: false,
      zonas: [],
      disponibilidades: []
    }
  },
  computed: {
    nombresZonas() {
      return this.zonas.map((zona) => zona.nombre).join(', ')
    }
  },
  watch: {
    usuario(newVal, oldVal) {
      if (oldVal.estaDisponible !== newVal.estaDisponible) {
        this.cargarInfoUsuario()
      }
    }
  },
  mounted() {
    this.$nextTick(() => this.cargarInfoUsuario())
  },
  methods: {
    cancelarDisponibilidad(id) {
      this.isLoading = true
      usuarioService
        .cancelarDisponibilidad(id)
        .then((response) => {
          this.notificarAccionCompletada(
            'Se ha cancelado la disponibilidad correctamente.'
          )
          this.$store
            .dispatch('disponibilidad/updateUsuarios')
            .catch((error) => this.procesarError(error))
          this.cargarInfoUsuario()
        })
        .catch((error) => this.procesarError(error))
        .then(() => (this.isLoading = false))
    },
    confirmarEliminacionDisponibilidad(id) {
      this.$buefy.dialog.confirm({
        title: 'Eliminar disponibilidad',
        message:
          '¿Est&aacute; seguro de <b>eliminar</b> &eacute;ste estado de disponibilidad de usuario? Esta acci&oacute;n no se puede deshacer.',
        confirmText: 'Eliminar',
        cancelText: 'Cancelar',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.cancelarDisponibilidad(id)
      })
    },
    cambiarEstadoHandle(payload) {
      this.isLoading = true
      const objeto = {
        usuarioId: this.usuario.id,
        objeto: payload
      }
      this.$store
        .dispatch('disponibilidad/updateUsuario', objeto)
        .then(() => this.cargarInfoUsuario())
        .catch((error) => this.procesarError(error))
        .then(() => (this.isLoading = false))
    },
    cargarInfoUsuario() {
      this.isLoading = true
      usuarioService
        .getInfoByUsuario(this.usuario.id, (error, response) => {
          if (!error) {
            this.zonas = response.zonas
            this.disponibilidades = response.disponibilidades
          } else {
            this.procesarError(error)
          }
        })
        .then(() => (this.isLoading = false))
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  table {
    thead {
      tr {
        th {
          text-align: center;
        }
      }
    }
  }
}
</style>
